module.exports = __webpack_public_path__ + "img/dead-grey-trunk-03.6ef816d9.png";